export enum ComponentDataSubscriptionModalMode {
  Create = 'create',
  Update = 'update'
}
